// Time & money helpers for the Time & Expenses module.
// Actual time is stored in minutes; billable time rounds UP to 6-minute (0.1 h) increments.

// Accepts "1:30" (HH:MM), "1.5" or "1,5" (decimal hours), or "90" (bare minutes).
// Returns minutes (int) or null.
export function parseTimeInput(s) {
  if (typeof s !== "string") return null;
  s = s.trim();
  if (!s) return null;
  const colon = s.match(/^(\d+):([0-5]?\d)$/);
  if (colon) return parseInt(colon[1], 10) * 60 + parseInt(colon[2], 10);
  if (/^\d+[.,]\d+$/.test(s)) return Math.round(parseFloat(s.replace(",", ".")) * 60);
  if (/^\d+$/.test(s)) return parseInt(s, 10);
  return null;
}

export function roundUpBilling(minutes) {
  return Math.ceil(minutes / 6) * 6;
}

export function fmtDecimalHours(minutes) {
  return `${(minutes / 60).toFixed(1)} h`;
}

export function fmtHM(minutes) {
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}`;
}

export function fmtMoney(n) {
  return `€${Number(n || 0).toFixed(2)}`;
}

export function fmtElapsed(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}
